import { useEffect, useState } from 'react';

import { call, classes } from 'utils';
import { ArrowDown } from 'assets/vector';

import styles from './ScrollButton.module.scss';

type Props = {
  visible?: boolean;
  counter?: number;
  onClick?: () => void;
};

type State = {
  visible?: boolean;
  hover?: boolean;
};

const ScrollButton = ({ visible, counter = 0, onClick }: Props) => {
  const [state, setState] = useState<State>({ visible });

  useEffect(() => {
    setState({ visible });
  }, [visible]);

  const enter = () => setState(state => ({ ...state, hover: true }));
  const leave = () => setState(state => ({ ...state, hover: false }));

  return (
    <div
      className={classes(
        styles.scrollButton,
        state.visible ? styles.visible : styles.hidden,
        state.hover ? styles.hover : ''
      )}
      onClick={() => {
        enter();
        call(onClick);
      }}
      onMouseEnter={enter}
      onMouseLeave={leave}
    >
      <ArrowDown />

      {counter > 0 ? (
        <div className={styles.badge}>{counter > 99 ? '+99' : counter}</div>
      ) : null}
    </div>
  );
};

export default ScrollButton;
